import * as z from 'zod';

import { clientOptQuerySchema } from './client-opt-schema';
import { deliverablesQuerySchema } from './deliverables-query-schema';

export const deliverablesUpdateSchema = deliverablesQuerySchema
  .pick({
    id: true,
    product_id: true,
    product_name: true,
    price_frequency_id: true,
    quantity: true,
    price: true,
    agreement_id: true,
    opted_in: true,
    opted_out: true,
  })
  .extend({
    sku: z.string(),
    sort_order: z.number(),
    client_opt: clientOptQuerySchema,
    product_id: z.number(),
    price_frequency_id: z.number(),
    lockdown_override_pin: z.string().optional(),
    override_justification_note: z.string().optional(),
  });

export type DeliverablesUpdateSchema = z.infer<typeof deliverablesUpdateSchema>;

export const deliverablesCreateSchema = deliverablesUpdateSchema.omit({ id: true });

export type DeliverablesCreateSchema = z.infer<typeof deliverablesCreateSchema>;
